import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import {
  IClinicOpeningHours,
  ISaveClinicOpeningHoursPayload,
} from '@dataTypes/clinic-opening-hours.type'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchClinicOpeningHoursApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ opening_hours: IClinicOpeningHours }>> => {
  const response = await axios.get<
    ApiEnvelope<{ opening_hours: IClinicOpeningHours }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/opening-hours`, {
    params: { clinic_id: clinicId },
  })
  return response.data
}

export const saveClinicOpeningHoursApi = async (
  clinicId: string,
  payload: ISaveClinicOpeningHoursPayload,
): Promise<ApiEnvelope<{ opening_hours: IClinicOpeningHours }>> => {
  const response = await axios.put<
    ApiEnvelope<{ opening_hours: IClinicOpeningHours }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/opening-hours/${clinicId}`, payload)
  return response.data
}
